export default __webpack_public_path__ + "static/media/a017-j.24df9fc5.svg";